import { Button, Col, Row } from "antd";
import { UserPlus } from "lucide-react";

import { WrapperCard } from "./styled";
import { TableUsers } from "./TableUser";
import { AdminMenuLayout, ModalUsers } from "../../../shared/components";
import { useUsers } from "../hooks/useUsers";
import { selectModalUser } from "../../../redux";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

export type UsersPageVariant = "system" | "clients" | "domiciliarios";

export const Users = ({ variant = "system" }: { variant?: UsersPageVariant }) => {
  const modalUser = useSelector(selectModalUser);
  const {
    isUpdateUser,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalUserState,
    openCreateUserModal,
  } = useUsers();
  const isSystem = variant === "system";
  const isDomiciliarios = variant === "domiciliarios";
  const layoutTitle = isSystem
    ? "Usuarios del sistema"
    : isDomiciliarios
      ? "Domiciliarios"
      : "Clientes";
  const layoutDescription = isSystem
    ? "Administradores y vendedores (sin repartidores)"
    : isDomiciliarios
      ? "Repartidores que atienden pedidos en la app"
      : "Clientes registrados en el restaurante (app / web)";

  return (
    <AdminMenuLayout pageDescription={layoutDescription} title={layoutTitle}>
      <WrapperCard>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {isSystem && (
            <Button
              type="primary"
              icon={<UserPlus size={18} />}
              size="large"
              onClick={changeModalUserState}
              style={{
                borderRadius: 20,
                height: 44,
                paddingLeft: 24,
                paddingRight: 24,
                fontWeight: 600,
                fontSize: 15,
                boxShadow: "0 2px 8px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Agregar usuario del sistema
            </Button>
            )}
            {isDomiciliarios && (
              <Button
                type="primary"
                icon={<UserPlus size={18} />}
                size="large"
                onClick={() =>
                  openCreateUserModal({
                    role: "domiciliary",
                    status: "active",
                  })
                }
                style={{
                  borderRadius: 20,
                  height: 44,
                  paddingLeft: 24,
                  paddingRight: 24,
                  fontWeight: 600,
                  fontSize: 15,
                  boxShadow: "0 2px 8px rgba(233, 87, 53, 0.3)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                Agregar domiciliario
              </Button>
            )}
          </Col>
        </Row>
        <TableUsers variant={variant} />
      </WrapperCard>
      {modalUser && isUpdateUser && (
        <FormProvider {...formMethodsUpdate}>
          <ModalUsers
            showModulePermissions={isSystem}
            roleSelectOptions={
              isDomiciliarios
                ? [
                    { value: "domiciliary", title: "Domiciliario" },
                    { value: "admin", title: "Administrador" },
                    { value: "seller", title: "Vendedor" },
                  ]
                : undefined
            }
          />
        </FormProvider>
      )}
      {modalUser && !isUpdateUser && (
        <FormProvider {...formMethodsCreate}>
          <ModalUsers
            showModulePermissions={isSystem}
            roleSelectOptions={
              isDomiciliarios
                ? [{ value: "domiciliary", title: "Domiciliario" }]
                : undefined
            }
          />
        </FormProvider>
      )}
    </AdminMenuLayout>
  );
};
